















import { LiveManagementLiveService } from "@/common/api";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "csvDropzoneComponent",
  components: {},
})
export default class csvDropzoneComponent extends Vue {
  public name: "csvDropzoneComponent";

  public onFilePicked(event) {
    const file = event.target.files[0];

    this.uploadCsv(file);

    const input = this.$refs.fileInput as HTMLInputElement;
    input.value = null;
  }

  private async uploadCsv(file) {
    const formData = new FormData();
    formData.append("csv", file);
    const result = await LiveManagementLiveService.adminLiveCsv(
      formData as any,
    );
    this.$emit("changeCsv", result);
  }
}
